import React, { useState, useEffect } from 'react';
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../../Navbar";
import Header from "../../Header";
import baseUrl from "../../BaseUrl";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { saveAs } from 'file-saver';


const CreateOrderSuccess = () => {

    const [name, setName] = useState('');
    const [token, setToken] = useState('');
    const [role, setRole] = useState('');
    const [expire, setExpire] = useState('');
    const [access, setAccess] = useState([]);
    const [cancelFailedMessage, setCancelFailedMessage] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const abx = location.state;

    useEffect(() => {
        refreshToken();
        getUserAccess();
        // getUsers();
    }, []);

    useEffect(() => {
        saveREsultApi();
        checkCancelMessage();
      }, [abx]);

   
    const saveREsultApi = async () => {
        const response = await axiosJWT.post(`${baseUrl}/save-result`, {data:abx}, {
            headers: {
                Authorization: `Bearer ${token}`
            }       
        });
        console.log(response);
    }

    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded.exp);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
        } catch (error) {
           
            if (error.response) {
                // setError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }
    const getUserAccess = async () => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
           
            console.log(response.data.results);
            setAccess(response.data.results);
            // setIsLoading(false);
            
        } catch (error) {
           console.log(error);
        //    setIsLoading(false);
            // if (error.response) {
            //     // setError("Unauthorized");
            //     navigate("/");  
            //     window.location.reload();
            // }
        }
    }

    const exportErrors = async (e) => {
        e.preventDefault();
        const keysToInclude = Object.keys(abx).filter(key =>{return key !== 'importError' && key !== 'Success' && key !== 'telephoneNumberOrder'});
        
        const telephoneNumberOrder = abx['telephoneNumberOrder']
        let csv;
        if(telephoneNumberOrder){
            const header = 'Tel Number,Status';
            // const rows = keysToInclude.map(key => `${key},${abx[key]}`);
            const rows = telephoneNumberOrder.map(phoneNumber => {
                const errorMessage = abx[phoneNumber.toString()];
                return `${phoneNumber},${errorMessage}`;
              });
            csv = `${header}\n${rows.join('\n')}`;
        }else{
            const header = 'Status';
            // const rows = keysToInclude.map(key => `${key},${abx[key]}`);
            const rows = [abx.status];
            csv = `${header}\n${rows.join('\n')}`;
        }
        
        // Create a Blob containing the CSV data
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      
        // Trigger the file download using file-saver
        saveAs(blob, 'ExportError.csv');
    }

    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    const checkCancelMessage = () => {
        
        if( 
            (abx.cancel && abx?.bandwidth?.inteliquentAll === 2 && abx?.inteliquent?.inteliquentAll === 2) ||
            (abx?.bandwidth?.inteliquentAll === 2 && !abx?.inteliquent) ||
            (abx?.inteliquent?.inteliquentAll === 2 && !abx?.bandwidth)
        ){
            setCancelFailedMessage(true);
        }
    }
    
    return (
        <div className="panelbox">
            <Navbar  token={token} access = {access}/>
            <div className="right-panel">
            <Header name={name} />
                <div className="content-page">
                    <div className="common-white-shadow-background setting-section number-thank-you-page">
                        <div className="row">
                           
                        {!abx.show &&<div className="number-thank-img">
                                 <img src="images/correct.png" />
                            </div>}
                            <div className="thank-msg">
                                {abx.order && (abx.carrierType === 0 || abx.carrierType === 1) &&(
                                <>
                                { abx.sansayAll && (abx.inteliquent?.inteliquentAll == 0 || abx.bandwidth?.inteliquentAll == 0) && <h3>Your order has been received.  The Broadband Dynamics team will update you on the status of your order.</h3>} {/* Your order has been completed.*/}
                                {abx.order && !abx.sansayAll && (abx.inteliquent?.inteliquentAll== 0 || abx.bandwidth?.inteliquentAll== 0) && <h3>Your order has been received.  The Broadband Dynamics team will update you on the status of your order.</h3>}
                                {((abx.order && abx.sansayAll && (abx.inteliquent?.inteliquentAll == 1 || abx.bandwidth?.inteliquentAll == 1)) || (abx.order && !abx.sansayAll && (abx.inteliquent?.inteliquentAll == 1 || abx.bandwidth?.inteliquentAll == 1))) && <h3>Your order has been received.  The Broadband Dynamics team will update you on the status of your order.</h3>}
                                {abx.order && !abx.sansayAll && (abx.inteliquent?.inteliquentAll == 2 || abx.bandwidth?.inteliquentAll == 2) && <h3>Your order was not successful.  The Broadband Dynamics team will update you on the status of your order.</h3>}
                                </>)}
                                {abx.order && abx.carrierType === 2 &&(
                                <>
                                
                                { <h3>Your order has been received.  The Broadband Dynamics team will update you on the status of your order.</h3>}                                
                                
                                </>)}
                                
                                {abx.cancel && cancelFailedMessage && <h3>Your request was not successful.  The Broadband Dynamics team will update you on the status of your request.</h3>}
                                {abx.cancel && !cancelFailedMessage && <h3>Your order has been received. The Broadband Dynamics team will update you on the status of your order.</h3>}

                               
                                {abx.features && abx.cname && (
                                    <>
                                        {((abx.inteliquent?.inteliquentAll === 1 || abx.inteliquent?.inteliquentAll === 0) ||
                                          (abx.bandwidth?.inteliquentAll === 1 || abx.bandwidth?.inteliquentAll === 0)) && (
                                            <h3>Your request has been received. The Broadband Dynamics team will update you on the status of your order.</h3>
                                        )}
                                        {((abx.inteliquent?.inteliquentAll === 2 || abx.bandwidth?.inteliquentAll === 2)) && (
                                            <h3>Your request was not successful. The Broadband Dynamics team will update you on the status of your request.</h3>
                                        )}
                                    </>
                                )}


                                 {abx.features && abx.e911 && (abx.bandwidth?.inteliquentAll === 0) &&  (
                                    
                                    <h3>Your request has been received. The Broadband Dynamics team will update you on the status of your order.</h3>
                                
                            )}
                                {abx.features && abx.e911 && (abx.bandwidth?.inteliquentAll === 2) &&  (
                                    
                                        <h3>Your request was not successful. The Broadband Dynamics team will update you on the status of your request.</h3>
                                    
                                )}
                                {(abx.nonSupportCarrier || abx.importUpcomingPort) && <h3>Your request has been received. The Broadband Dynamics team will update you on the status of your order.</h3>}
                                {abx.importError && <h3>We have processed your request. Please download the status for each numbers using below button.</h3>}
                                {abx.importInventory && <h3>We are processing your import inventory request. You can check the import log in the <a href="import-inventory-history">Import DID Inventory History</a> Page.</h3>}                                
                                {abx.importNoteInventory && <h3>We are processing your import inventory request. You can check the import log in the <a href="import-notes-into-inventory-history">Import Note Inventory History</a> Page.</h3>}
                                {abx.importNonSupportCarrierCnam && <h3>We are processing your import inventory request. You can check the import log in the <a href="import-non-supported-carrier-cnam-history">Import Non Supported Carrier CNAM History</a> Page.</h3>}                                
                                {abx.importSupportCarrierCnam && <h3>We are processing your import inventory request. You can check the import log in the <a href="import-supported-carrier-cnam-history">Check Supported Carrier CNAM History</a> Page.</h3>}                                
                                {abx.checkTNSDetail && <h3>We have processed your check number status request. You can check log into <a href="dialed-number/list">Telephone Number Status</a> Page.</h3>}                                                      
                                {abx.ciaNumberSetting && <h3>File submitted successfully please check <a href="cia-number-setting-history">Enable E-NRMS History</a> page for the result file.</h3>}          
                                {abx.importCallPass && <h3>We are processing your import call pass settings request. You can check the import log in the <a href="import-call-pass-history">Import Call Pass History</a> Page.</h3>}
                                {abx.importNumberRemove && <h3>We are processing your import inventory request. You can check the import log in the <a href="import-portal-number-remove-history">Import Number Remove History</a> Page.</h3>}
                                {abx.enrmsBatchNumberRemove && <h3>We are processing your import inventory request. You can check the import log in the <a href="enrms-remove-batch-number-history">ENRMS Batch Number Remove History</a> Page.</h3>}
                                {abx.importDoNotOriginate && <h3>We are processing your import inventory request. You can check the import log in the <a href="import-do-not-originate-history">Import Do Not Originate History</a> Page.</h3>}
                                {abx.importNoNumberReputation && <h3>We are processing your import inventory request. You can check the import log in the <a href="import-no-number-reputation-history">Import No Number Reputation History</a> Page.</h3>}
                                {abx.internationalNumberOrder && <h3>Your request has been received. The Broadband Dynamics team will update you on the status of your order.</h3>}
                                {abx.importDMTSync && <h3>We are processing your DMT Sync request. You can check the import log in the <a href="import-dmt-sync-history">Import DMT Sync History</a> Page.</h3>}
                                {abx.importInventoryTags && <h3>We are processing your import inventory request. You can check the import log in the <a href="import-inventory-tags-history">Import Inventory Tags History</a> Page.</h3>}                                
                                {abx.importCallPassDiridTn && <h3>We are processing your import call pass display identity telephone numbers request. You can check the import log in the <a href="import-call-pass-dirid-tn-history">Import Call Pass Display Identity History</a> Page.</h3>}
                                {abx.importEnrmsLoaDate && <h3>We are processing your import ENRMS LOA Date request. You can check the import log in the <a href="import-enrms-loa-date-history">Import ENRMS LOA Date History</a> Page.</h3>}
                                <div>
                                    {!abx.importEnrmsLoaDate && !abx.importUpcomingPort && !abx.importCallPassDiridTn && !abx.importInventoryTags && !abx.importDMTSync && !abx.importNoNumberReputation && !abx.importDoNotOriginate && !abx.enrmsBatchNumberRemove && !abx.importNumberRemove && !abx.importSupportCarrierCnam && !abx.importNonSupportCarrierCnam && !abx.importError && !abx.importInventory && !abx.importCallPass && !abx.ciaNumberSetting && !abx.checkTNSDetail && !abx.nonSupportCarrier && !abx.importNoteInventory && <table  className="tablebox search-result-table order-result-table">
                                        
                                        <tbody>
                                          <tr>
                                            <td>
                                                <strong>Order Id :- </strong>
                                            </td>
                                            <td>
                                                {abx.orderId}
                                            </td>
                                        </tr>                                             
                                        </tbody>
                                    </table>}
                                </div>
                                
                                {!abx.importEnrmsLoaDate && !abx.importCallPassDiridTn && !abx.importInventoryTags && !abx.importDMTSync && !abx.importNoNumberReputation && !abx.importDoNotOriginate && !abx.enrmsBatchNumberRemove && !abx.importNumberRemove && !abx.importSupportCarrierCnam && !abx.importNonSupportCarrierCnam && !abx.importCallPass && !abx.importInventory && !abx.importNoteInventory && !abx.checkTNSDetail &&  !abx.ciaNumberSetting && <Link className="yellow-btn" to={"/number-management"}>Done</Link>}
                                {abx.importError && <a href="#" className='error-btn' onClick={exportErrors}>Export Results</a>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default CreateOrderSuccess